import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetInboundWhatsAppRules as GetInboundWhatsAppRulesQuery} from 'nutshell-graphql-types';

import GET_INBOUND_WHATSAPP_RULES from '../queries/get-inbound-whatsapp-rules.graphql';

export const useGetInboundWhatsAppRules = () => {
    const {data, error, loading, refetch} = useQuery<
        GetInboundWhatsAppRulesQuery,
        Record<any, any>
    >(GET_INBOUND_WHATSAPP_RULES, {});

    const {inboundWhatsAppRules} = makeDataDangerous(data);

    return {
        inboundWhatsAppRules,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
